import {Component, OnInit} from "@angular/core";
import {PagesService} from "../../services/pages.service";
import {ActivatedRoute} from "@angular/router";
import { Title } from '@angular/platform-browser';
import {MetatagService} from '../../services/metatag.service';

@Component({
    selector: 'page',
    templateUrl: './pages.component.html'
})
export class PagesComponent implements OnInit {
    public pageFound: boolean = true;

    public title: string = '';
    public content: string = '';
    public nid: number = 0;
    public alpha_content: Object = {};
    
    public breadcrumbs: Object[] = [{
        url: '/',
        label: 'Home',
        nid: 0,
    },{
        label: 'Over Dermabase',
        nid: 0,
    }];

    constructor(
        private titleService: Title,
        private pagesService: PagesService,
        private activatedRoute: ActivatedRoute,
        private metatagService: MetatagService
    ){}

    
    ngOnInit() {
        this.activatedRoute.url.subscribe((path) => {
            let fullPath = path.join('/');
            this.pagesService.get(fullPath).subscribe((res)=>{
                this.pageFound = true;
                this.title = res.title[0].value;
                this.content = res.body[0].value;
                this.breadcrumbs[1]['label'] = this.title;
                this.breadcrumbs[10] = res.nid[0].value;
                // change one page in particular
                this.nid = res.nid[0].value;
                this.alpha_content = [
                    'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W',
                    'X','Y','Z'
                ];
                this.titleService.setTitle(this.title + ' - Dermabase');

                const desc: string = (res.field_me.length) ? res.field_me[0].value : '';
                const keywords: string = (res.field_meta_keywords.length) ? res.field_meta_keywords[0].value : '';

                this.metatagService.setMetaTags(desc, keywords);
            },(error) => {
                this.pageFound = false;
                this.title = '';
                this.content = '';
                this.breadcrumbs = null;
                this.nid = 0;

                this.titleService.setTitle('Dermabase - 404 page not found');
            });
        });
    }

    scrollTo(letter) {
        this.alpha_content = [
            'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W',
            'X','Y','Z'
        ];
        for(var i=0;i<26;i++) {
            document.getElementById('alpha_id_'+this.alpha_content[i]).style.borderBottom = 'none';
        }
        document.getElementById('alpha_id_'+letter).style.borderBottom = '3px solid #1a448a';
        let el = document.getElementById(letter);
        el.scrollIntoView();

    }
}


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/pages/pages.component.ts